import "core-js/actual";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { rootReducer } from "./reducers/rootReducer";
import reduxStore from "./reducers/store";

import { ToastContainer } from "react-toastify";

import AxiosWrapper from "./services/AxiosWrapper";
import "react-toastify/dist/ReactToastify.css";
import * as serviceWorker from "./serviceWorker";

import App from "./App";

import "./styles/main.scss";

const appReducers = {};
const store = reduxStore(rootReducer(appReducers));
AxiosWrapper.reduxStore = store;
ReactDOM.render(
  <Provider store={store}>
    <App />
    <ToastContainer autoClose={3000} />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
